import Vue from 'vue'
import {
  getTime,
  differenceInDays
} from 'date-fns'
import i18n from './i18n.plugin'
/**
 * Global Variables
 */

/**
 * Global Functions
 */
export const getSafe = (fn, defaultVal) => {
  try {
    return fn()
  } catch (e) {
    return defaultVal
  }
}
Vue.prototype.$getSafe = getSafe

export const getElapsedTime = ({ secondsInterval }) => {
  const years = secondsInterval / (3600 * 24 * 30 * 12)
  const months = (years % 1) * 12
  const days = (months % 1) * 30
  const hours = (days % 1) * 24
  const minutes = (hours % 1) * 60
  const seconds = (minutes % 1) * 60
  const allComponents = { years: Math.floor(years), months: Math.floor(months), days: Math.floor(days), hours: Math.floor(hours), minutes: Math.floor(minutes), seconds: Math.round(seconds) }
  return allComponents
}
Vue.prototype.$getElapsedTime = getElapsedTime

export const getDateString = ({ date, needOffset = false, timeDetailLevel = 1 }) => {
  if (!date) return date
  date = getTime(date)

  if (date.toString().length < 13) {
    date = date * 1000
  }

  if (needOffset) {
    const utcOffset = new Date().getTimezoneOffset() * 60000
    date = date - utcOffset
  }
  // if (showTime) return format(date, 'YYYY-MM-DD')
  // return format(date, 'YYYY-MM-DD HH:mm:ss [GMT]Z')
  let timeZone = null
  const dateTimeZone = new Date()
  const regex = /GMT-0\d/
  const match = dateTimeZone.toString().match(regex)
  if (match) {
    timeZone = match[0]
  } else {
    timeZone = null
  }

  switch (timeDetailLevel) {
    case 0:
      return i18n.d(date, 'date')
    case 1:
      return `${i18n.d(date, 'minute').replace(',', '')} ${timeZone}`
    case 2:
      return `${i18n.d(date, 'second').replace(',', '')} ${timeZone}`
    default:
      return i18n.d(date, 'date')
  }
}
Vue.prototype.$getDateString = getDateString

export const getUnixDateMs = ({ date }) => {
  return getTime(date)
}
Vue.prototype.$getUnixDateMs = getUnixDateMs

export const utf8Decode = utf8String => {
  if (typeof utf8String !== 'string') { throw new TypeError('parameter ‘utf8String’ is not a string') }
  // note: decode 3-byte chars first as decoded 2-byte strings could appear to be 3-byte char!
  const unicodeString = utf8String
    .replace(
      /[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g, // 3-byte chars
      function (c) {
        // (note parentheses for precedence)
        const cc =
          ((c.charCodeAt(0) & 0x0f) << 12) |
          ((c.charCodeAt(1) & 0x3f) << 6) |
          (c.charCodeAt(2) & 0x3f)
        return String.fromCharCode(cc)
      }
    )
    .replace(
      /[\u00c0-\u00df][\u0080-\u00bf]/g, // 2-byte chars
      function (c) {
        // (note parentheses for precedence)
        const cc = ((c.charCodeAt(0) & 0x1f) << 6) | (c.charCodeAt(1) & 0x3f)
        return String.fromCharCode(cc)
      }
    )
  return unicodeString
}
Vue.prototype.$utf8Decode = utf8Decode

export const getLabelDecorationForExpiration = (date) => {
  const daysEllapsed = differenceInDays(date, new Date())
  if (daysEllapsed < 0) return { condition: 'red', expired: true }
  else if (daysEllapsed < 30) return { condition: 'red' }
  else if (daysEllapsed < 45) return { condition: 'orange' }
  else if (daysEllapsed < 60) return { condition: 'blue' }
  else return null
}
